import(/* webpackMode: "eager" */ "/app/src/app/data&ai/layout.js");
